import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { getFullDate } from 'shared/helpers/moment';
import Link from 'shared/components/Link';
import { urlReplace } from 'shared/modules';
import newsImg from 'shared/assets/images/newspaper.svg';
import s from './NewsItem.css';
import withPixelRatio from '../../hocs/withPixelRatio';

export const TYPES = {
  TABLE: 'table',
  LIST: 'list',
};
const isMobile = __APP__ === 'mobile';

export const itemPropType = {
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  image: PropTypes.shape({
    id: PropTypes.number,
    url: PropTypes.string,
    title: PropTypes.string,
    caption: PropTypes.string,
  }).isRequired,
  // not required
  className: PropTypes.string,
  author: PropTypes.shape(),
  publication_date: PropTypes.string.isRequired,
  imgHeight: PropTypes.number,
  type: PropTypes.string,
  isPrimary: PropTypes.bool,
  isActive: PropTypes.bool,
  getSelVideo: PropTypes.func,
};

class NewsItem extends React.Component {
  static propTypes = {
    ...itemPropType,
    setRatioImage: PropTypes.func.isRequired,
    lensEvent: PropTypes.string,
    //
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    getSelVideo: () => {},
    lensEvent: '',
    className: '',
    author: null,
    date: null,
    isPrimary: false,
    isActive: false,
    imgHeight: 200,
    type: TYPES.TABLE,
  };

  render() {
    const {
      isActive,
      title,
      title_uk: titleUk,
      link,
      image,
      className,
      imgHeight,
      publication_date: date,
      type,
      author,
      isPrimary,
      setRatioImage,
      intl,
      getSelVideo,
      lensEvent,
    } = this.props;

    const { first_name: firstName = null, last_name: lastName = null } = author;
    const { locale } = intl;
    const fullDate = getFullDate(date, locale);
    const authorName = [firstName, lastName].filter(x => x).join(' ');
    //
    const isList = type === TYPES.LIST;
    const hasImage = !!image.url;
    const imageSrc =
      image && setRatioImage(image.url, ...(isPrimary ? [750, null] : [240, 200]), 'contain');
    const localizedTitle = locale === 'ru' ? title || titleUk : titleUk || title;

    return (
      <div
        className={cx(className, {
          [s.listNews]: isList,
          [s.tableNews]: !isList,
          [s.primary]: isPrimary,
          [s.active]: isActive,
        })}
        onClick={() => getSelVideo()}
      >
        <div
          className={cx({
            [s.listThumb]: isList,
            [s.tableThumb]: !isList,
            [s.placeholderThumb]: !hasImage,
            [s.imageTabletHeight]: isMobile,
          })}
          style={
            imgHeight
              ? { backgroundImage: `url(${urlReplace(imageSrc || newsImg)})`, height: imgHeight }
              : {}
          }
        >
          <Link className={s.stretchedLink} to={link} data-lens-event={lensEvent}>
            <span />
          </Link>
        </div>

        <div className={cx({ [s.listText]: isList, [s.tableText]: !isList })}>
          <div>
            <Link to={link} className={s.link} data-lens-event={lensEvent}>
              {localizedTitle}
            </Link>
            {fullDate && !isList && <div className={s.tableDate}>{fullDate}</div>}
          </div>

          <div className={s.listBottom}>
            <div className={s.listBottomCard}>
              {author.avatar && <img src={author.avatar} className={s.avatar} alt="" />}
              <div>
                {author && author.id && authorName && (
                  <span className={s.author}>{authorName}</span>
                )}
                {fullDate && isList && <div className={s.listDate}>{fullDate}</div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(withPixelRatio(NewsItem)));



// WEBPACK FOOTER //
// ./src/shared/components/NewsItem/NewsItem.js